module.exports = __webpack_public_path__ + "img/chevron-right.e92349e5.svg";